// extracted by mini-css-extract-plugin
export default {"inputUrl":"Sandbox_inputUrl__fXrDA","tabs":"Sandbox_tabs__++FET","limitsCards":"Sandbox_limitsCards__J-fNK"};